// extracted by mini-css-extract-plugin
export default {"buying_guide":"buying-guide_buying_guide__+xwmw","image_container":"buying-guide_image_container__SWRgx"};